import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-end -mt-7 helpCardWrapper" }
const _hoisted_2 = { class: "helpCard" }
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "grid mt-1" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconTextBlock = _resolveComponent("IconTextBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.settings.content.needHelpText")), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_IconTextBlock, {
            icon: "icon-mobile",
            label: _ctx.location.phone_number,
            href: `tel:${_ctx.location.phone_number}`
          }, null, 8, ["label", "href"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_IconTextBlock, {
            icon: "icon-envelope",
            label: _ctx.location.email,
            href: `mailto:${_ctx.location.email}`
          }, null, 8, ["label", "href"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.t("content.settings.content.firstSignIn")) + ":", 1)
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getUser.createdDate), 1)
      ])
    ])
  ]))
}